import React from 'react';
import JobSingle from './JobSingle';

//api calls
import jobstreamurl from '../api/jobs.js'
import axios from 'axios'

class App extends React.Component {

  state = {
    jobId: '',
    jobs: [],
    socialshares: [],
    SingleJobselectionData: [],
  }

  constructor(props) {
    super(props);
    this.state = {
      jobId: props.jobId,
      SingleJobselectionData: props.SingleJobselectionData,
    };
  }

  componentDidMount() {
    console.log('inside mount');
    this.fetchJobstreamUrl();
  }

  fetchJobstreamUrl = async () => {
    console.log('inside fetchJobstreamUrl');
    this.setState({
      jobstreamurl : "",
    },
      this.fetchAllData
    );
  }

  fetchJobs = async (id) => {
    console.log('inside fetchJobs: ' + this.state.jobId);
    const response = await axios.get(
      "/wp-json/macs/v1/single-job-api" + '?cg_job_id=' + this.state.jobId
    ).then(response =>
      this.setState({
        jobs : response.data,
      },
        this.fetchSocialShareIcons
      )
    );
  }

  fetchAllData = async () => {
    this.fetchJobs();
  }

  fetchSocialShareIcons = async () => {
    const response = await axios.get(
      '/wp-json/macs/v1/socialshareurls'
    ).then(response =>
      this.setState({
        socialshares : response.data,
      })
    );
  }

  render() {
    return (
      <div className="single-job">
        {( (typeof this.state.jobs === 'undefined' || ( this.state.jobs._id !== undefined && this.state.jobs.deleted_at !== null )) ) ? (
          <div></div>
        ) : (
          <React.Fragment>
            <JobSingle jobs={this.state.jobs} socialshares={this.state.socialshares} SingleJobselectionData={this.state.SingleJobselectionData} />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default App;
